import { TokenResponse } from '@openid/appauth';
import { createTokenRefresher } from '@oolio-group/client-utils';
import jwt_decode from 'jwt-decode';
import config from '../config';
import { tokenState, tokenUpdated } from '../state/apolloVars';
import * as settings from '../state/preferences';

// Shared across every refresh trigger in kds-app (this file, and
// authFlowLink.ts's GraphQL TokenRefreshLink) so they single-flight behind
// one in-flight Auth0 exchange instead of racing each other. Confirmed live:
// docket-bump and docket-poll racing this way was reproduced during PR
// testing, triggering Auth0's rotation reuse detection.
export const refresh = createTokenRefresher(
  {
    clientId: config.auth0.clientId,
    redirectUrl: config.auth0.redirectUrl,
    issuer: config.auth0.issuer || '',
  },
  async () => (await settings.getSession())?.refreshToken,
  async refreshToken => {
    const session = await settings.getSession();
    if (!session?.refreshToken) return;
    await settings.setSession({ ...session, refreshToken });
  },
);

export const refetchTokenSerially = async () => {
  const session = await settings.getSession();
  const response = await refresh();
  const { accessToken, refreshToken } = response as unknown as TokenResponse;
  const accessTokenPayload = jwt_decode<{
    exp: number;
  }>(accessToken as string);
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  const newTokenPayload: any = {
    token: accessToken as string,
    refreshToken: refreshToken as string,
    expiredDate: accessTokenPayload.exp * 1000,
  };
  tokenState(newTokenPayload);
  await settings.setSession({
    ...session,
    ...newTokenPayload,
  });
  tokenUpdated({ timestamp: Date.now() });
  return { accessToken };
};
